import './Notification.scss';

export { default } from './Notification';
